export class Login {
    email_mobile:string;
    password:string;
    type:string="Web";
    password_otp:string="";
}
